module.exports = __webpack_public_path__ + "static/media/ESI_Slide_45_Right_Img.0f3048f2.png";